import { Entity } from "@shared/entities/entity";
import { JsonObject, JsonProperty } from "json2typescript";

@JsonObject('Notification')
export class Notification extends Entity {
	@JsonProperty("title")
	title?: string;
	@JsonProperty("description")
	description?: string;
	@JsonProperty("date")
	date?: Date;
	@JsonProperty("route")
	route?: string;
}